module.exports = __webpack_public_path__ + "img/asia08.318c48d0.png";